module.exports = __webpack_public_path__ + "img/40_38_027_301.3e80c729.jpg";